import { R as ensure_array_like, Q as attr, S as escape_html, Y as stringify } from "./index.js";
import { D as DownloadButton } from "./DownloadButton.js";
import { P as PurchaseButton } from "./PurchaseButton.js";
function check($$payload, dark = true) {
  $$payload.out += `<svg${attr("class", `h-6 w-5 flex-none ${stringify(dark ? "text-teal-600" : "text-teal-500")}`)} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"></path></svg>`;
}
function Pricing($$payload) {
  const pricing = [
    {
      title: "Free",
      price: "$0",
      frequency: "forever",
      description: "Ideal for basic display brightness control.",
      features: [
        "Individual Brightness Adjustment (Up to 2 displays)",
        "Profiles (Create or use preset brightness levels)",
        "Expanded/Compact View",
        "Light/Dark Mode",
        "Auto Startup",
        "Auto Detect Displays"
      ]
    },
    {
      title: "PRO",
      price: "$1.99 - $5.99",
      frequency: "/one-time",
      description: "Unlock enhanced features and support development by choosing how much you want to pay.",
      features: [
        "Individual Brightness Adjustment (Unlimited displays)",
        "Global Brightness Slider",
        "Schedules",
        "Shade Mode",
        "Universal Display Compatibility",
        "All Free Features Included"
      ]
    }
  ];
  const each_array = ensure_array_like(pricing);
  $$payload.out += `<div class="section-container bg-white"><div class="section py-12 pb-24"><div class="grid grid-cols-1 gap-12 items-center z-10 relative"><div class="mx-auto max-w-4xl text-center"><h2 class="text-base/7 font-semibold text-teal-600 font-display">Pricing</h2> <p class="mt-2 font-display text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">Choose What Works Best for You</p> <p class="mx-auto mt-6 max-w-2xl text-pretty text-center text-lg text-gray-600 sm:text-xl/8">Glimmr offers a free version for essential brightness control, plus an optional
					paid license for full functionality.</p></div> <div class="relative isolate"><div class="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl" aria-hidden="true"><div class="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"></div></div> <div class="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let {
      title,
      price,
      description,
      features,
      frequency
    } = each_array[i];
    const isPro = title === "PRO";
    const each_array_1 = ensure_array_like(features);
    $$payload.out += `<div${attr("class", `rounded-3xl sm:mx-8 sm:rounded-b-none sm:p-10 lg:mx-0 lg:rounded-bl-3xl lg:rounded-tr-none p-8 ${stringify(isPro ? "bg-teal-950 text-white !rounded-3xl shadow-lg" : "bg-white/60 ring-1 ring-gray-900/10")}`)}><h3${attr("id", "tier-" + title.toLowerCase())} class="text-base/7 font-light text-teal-500">${escape_html(title)}</h3> <p class="mt-4 flex items-baseline gap-x-2"><span class="text-5xl font-semibold tracking-tight">${escape_html(price)}</span> <span class="text-base opacity-70">${escape_html(frequency)}</span></p> <p class="mt-6 text-base/7">${escape_html(description)}</p> <ul role="list" class="mt-8 space-y-3 text-sm/6 sm:mt-10"><!--[-->`;
    for (let $$index = 0, $$length2 = each_array_1.length; $$index < $$length2; $$index++) {
      let feature = each_array_1[$$index];
      $$payload.out += `<li class="flex gap-x-3">`;
      check($$payload, !isPro);
      $$payload.out += `<!----> ${escape_html(feature)}</li>`;
    }
    $$payload.out += `<!--]--></ul> `;
    if (isPro) {
      $$payload.out += "<!--[-->";
      PurchaseButton($$payload, {
        class: "w-full mt-12",
        size: 2,
        background: "dark"
      });
    } else {
      $$payload.out += "<!--[!-->";
      DownloadButton($$payload, {
        class: "w-full mt-12",
        size: 2,
        background: "light",
        primary: false
      });
    }
    $$payload.out += `<!--]--></div>`;
  }
  $$payload.out += `<!--]--></div></div></div></div></div>`;
}
export {
  Pricing as P
};
